// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"Popup_popupContainer__2irJk","popupCard":"Popup_popupCard__1CVdF","closeBtn":"Popup_closeBtn__cQWhP"};